import axios from "@/utils/axios.js";

// 购物清单相关接口

// 加入购物车

export function addShop(data) {
  return axios({
    url: `/shopCart/add`,
    method: "post",
    data
  });
}

// 购物清单列表
export function getShopList(params) {
  return axios({
    url: `/shopCart/list`,
    method: "get",
    params
  });
}

//购物车删除
export function delShopList(data) {
  return axios({
    url: `/shopCart/delete`,
    method: "delete",
    data
  });
}

//清除失效购物车删除
export function delLoseShopList(data) {
  return axios({
    url: `/shopCart/deleteInvalid?code=${data.code}&authorizationType=${
      data.authorizationType
    }`,
    method: "delete",
    data
  });
}

//修改格式
export function updatePattern(data) {
  return axios({
    url: `/shopCart/updatePattern?id=${data.id}&pattern=${data.pattern}`,
    method: "PUT",
    data
  });
}

// 查询购物数量

export function getShopNum(params) {
  return axios({
    url: `/shopCart/count`,
    method: "get",
    params
  });
}

// 购物车下载
export function shopListDownLoad(data) {
  return axios({
    url: `/shopCart/download`,
    method: "post",
    data
  });
}

//购物车支付
export function shopListPay(params) {
  return axios({
    url: `/shopCart/pay`,
    method: "get",
    params
  });
}



//////////////////
// WEBPACK FOOTER
// ./src/api/shop.js
// module id = S49b
// module chunks = 41